// src/main.ts

// Import the explicit router initializer instead of relying on side-effects
import { initRouter } from "./router";

import "./index.css";
import "./pages/Home.css";

import { useAuth } from "./context/useAuth";
import { useTheme } from "./context/useTheme";

/**
 * Orchestrates the application bootstrap process in the correct sequence.
 */
async function bootstrap() {
  try {
    const { theme, applyTheme } = useTheme();
    applyTheme(theme);

    const { init } = useAuth();
    await init();

    initRouter();
  } catch (error) {
    console.error("Application bootstrap failed:", error);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
} else {
  void bootstrap();
}
